import * as React from "react";
import Box from "@mui/material/Box";
import { Tab, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import _, { debounce } from "lodash";
import moment from "moment";
import HttpService from "../../../hooks/Https-services";
import { APIRoutes } from "../../../utils/constants";
import useConfig from "../../../hooks/useConfig";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import GamesTable from "./GamesTable";
import { a11yProps } from "../Ads";

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement>,
    newPage: number
  ) => void;
}

export default function Games() {
  const [value, setValue] = React.useState("live");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const [keyword, setKeyword] = React.useState("");
  const handleKeywordChange = debounce((value: string) => {
    setKeyword(value);
  }, 300); //
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", py: 2 }}>
        <Typography variant="h3">Games</Typography>
        <TextField
          size="small"
          placeholder="Search"
          onChange={(e: any) => {
            handleKeywordChange(e.target.value);
          }}
          //   value={keyword}
        />
      </Box>
      <TabContext value={value}>
        <Box sx={{ borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Live" value="live" />
            <Tab label="VOD" value="vod" />
          </TabList>
        </Box>
        <TabPanel sx={{ px: 0 }} value={value}>
          <GamesTable status={value} keyword={keyword} />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
